import { APICore } from './apiCore'

const api = new APICore()

function getRegistros (params) {
  const baseUrl = '/registros'
  return api.get(baseUrl, params)
}

function getDataCharts (params) {
  const baseUrl = '/registros/charts'
  return api.get(baseUrl, params)
}

function getDataChartsComparisons (params) {
  const baseUrl = '/registros/chartsComparisons'
  return api.get(baseUrl, params)
}

function getRegistrosForExcel (params) {
  const baseUrl = '/registros/excel'
  return api.get(baseUrl, params)
}

function getRegistrosForExcelRA (params) {
  const baseUrl = '/registros/excelRA'
  return api.get(baseUrl, params)
}

function getRegistrosItSendStat (params) {
  const baseUrl = '/registros/itSendStat'
  return api.get(baseUrl, params)
}

function addRegistro (params) {
  const baseUrl = '/registros'
  return api.create(baseUrl, params)
}

export { getRegistros, getDataCharts, getDataChartsComparisons, getRegistrosForExcel, getRegistrosForExcelRA, getRegistrosItSendStat, addRegistro }
